import { faMagnet, faRocket, faSmile } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import ChooseRightDetails from './ChooseRightDetails';


const chooseLeftData = [
    {
     id:1,
     icon:faSmile,
     title:"SATISFACTION GUARANTEE",
     description:"A money-back guarantee, also known as a satisfaction guarantee, is essentially a simple guarantee that, if a buyer is not satisfied with a product or service, a refund will be made."
    },
    {
        id:2,
        icon:faRocket,
        title:"UNLIMITED REVIEW AND CHANGES",
        description:"We provide an unlimited Review for customer satisfaction. That's why a customer take a good decision to build his/her website very very interesting & attractive."
    },
    {
        id:3,
        icon:faMagnet,
        title:"ON-TIME DELIVERY",
        description:"On-Time Delivery is our responsibility. We confirm that your order is being provided in just time."
     },
]

const ChooseRight = () => {
    return (
        <div>
        {
            chooseLeftData.map(data=> <ChooseRightDetails key={data.id} data={data}/>)
        }
    </div>
    );
};

export default ChooseRight;